import { action, isAbortError } from '@reatom/framework'

import { Option, Result } from '@blade/std-lib'
import { UnknownError } from '@root/shared'

import { BlueskyPostOembed } from '../model/bluesky-post-oembed'
import * as KnownSocialPlatformResource from '../model/known-social-platform-resource'

interface GetBlueskyPostOembedRequestActionParams {
  resource: KnownSocialPlatformResource.BlueskyKnownSocialPlatformResource
}

export const getBlueskyPostOembedRequestAction = action(
  async (
    ctx,
    params: GetBlueskyPostOembedRequestActionParams,
  ): Promise<Result.Result<BlueskyPostOembed, UnknownError>> => {
    try {
      const oembedUrl = KnownSocialPlatformResource.toBlueskyOembedUrl(
        params.resource,
      )

      const response = await ctx.schedule(() => fetch(oembedUrl.toString()))

      if (!response.ok) {
        return Result.fail(
          UnknownError.fromUnknown(
            `Bluesky oembed request failed: ${response.status}`,
          ),
        )
      }

      const json = (await ctx.schedule(() => response.json())) as unknown

      const decoded = BlueskyPostOembed.decode(json)

      if (Option.isNone(decoded)) {
        return Result.fail(
          UnknownError.fromUnknown('Failed to decode bluesky post oembed'),
        )
      }

      return Result.succeed(decoded.value)
    } catch (error) {
      if (isAbortError(error)) {
        throw error
      }
      return Result.fail(UnknownError.fromUnknown(error))
    }
  },
  'getBlueskyPostOembedRequestAction',
)
